import { render, staticRenderFns } from "./SurfacePostComments.vue?vue&type=template&id=64c96b67&"
import script from "./SurfacePostComments.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports